var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tradeNewestList ? _c('div', {
    staticClass: "mTransaction",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "mTransaction-main"
  }, [_c('div', {
    ref: "carouselRef",
    staticClass: "mTransaction-list"
  }, [_vm.tradeNewestList && _vm.tradeNewestList.length > 0 ? _vm._l(_vm.tradeNewestList, function (item, index) {
    return _c('div', {
      key: index,
      ref: "itemRef",
      refInFor: true,
      staticClass: "mTransaction-item hover",
      class: item.type,
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('div', {
      staticClass: "mTransaction-type"
    }, [_vm._v(_vm._s(item.type === "buy" ? "BUY" : "SELL"))]), _c('div', {
      staticClass: "mTransaction-icon"
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty')], 1), _c('div', {
      staticClass: "mTransaction-info"
    }, [_c('div', {
      staticClass: "mTransaction__addr"
    }, [_vm._v(_vm._s(_vm._f("fmt_addr")(item.address, 16)))]), _c('div', {
      staticClass: "mTransaction__label"
    }, [_c('em', {
      domProps: {
        "innerHTML": _vm._s(_vm.fmt_pre(Number(item.ether_amount).toFixed(18), 4))
      }
    }), _vm._v(_vm._s(_vm.web3Wallet.symbol) + " of "), _c('i', [_vm._v(_vm._s(item.name))])])])]);
  }) : _vm._l(8, function (_) {
    return _c('div', {
      staticClass: "mTransaction-item empty"
    }, [_c('div', {
      staticClass: "mTransaction-icon"
    }), _vm._m(0, true)]);
  })], 2)])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mTransaction-info"
  }, [_c('div', {
    staticClass: "mTransaction__addr"
  }), _c('div', {
    staticClass: "mTransaction__label"
  })]);
}];
export { render, staticRenderFns };